import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import axios, { API, formatApiError } from "@/lib/apiClient";

export const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-lg border border-surface-border bg-surface-card p-8 fade-up">
        <h1 className="mb-6 font-heading text-2xl font-bold text-white">Set a new password</h1>
        {done ? (
          <p className="text-sm text-truth-green" data-testid="reset-password-success">Password reset. Redirecting to login...</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
            <Input type="password" required minLength={6} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="reset-password-input" />
            {error && <p className="text-sm text-sovereign">{error}</p>}
            <Button type="submit" disabled={loading || !token} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="reset-password-submit-btn">
              {loading ? "Resetting..." : "Reset password"}
            </Button>
          </form>
        )}
        <p className="mt-4 text-center text-sm text-slate-500">
          <Link to="/login" className="text-sovereign" data-testid="reset-password-login-link">Back to login</Link>
        </p>
      </div>
    </div>
  );
};
